import AppLayout from "Layout/Layout";
import { NonIndexRouteObject } from "react-router";
import { getResourcePath } from "./constant";
import { ListPage } from "pages/ho-so-ca-nhan/list-page";
import { DetailPage } from "pages/ho-so-ca-nhan/detail-page";
import { EditPage } from "pages/ho-so-ca-nhan/edit-page";
import { CreatePage } from "pages/ho-so-ca-nhan/create-page";

export const hoSoCaNhanRouters: NonIndexRouteObject[] = [
  {
    path: getResourcePath("ho-so-ca-nhan", "list"),
    element: (
      <AppLayout>
        <ListPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("ho-so-ca-nhan", "detail"),
    element: (
      <AppLayout>
        <DetailPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("ho-so-ca-nhan", "edit"),
    element: (
      <AppLayout>
        <EditPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("ho-so-ca-nhan", "create"),
    element: (
      <AppLayout>
        <CreatePage />
      </AppLayout>
    ),
  },
];
